module.exports = __webpack_public_path__ + "img/error1.5288d734.jpg";